import script from "./FreelanceDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./FreelanceDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./FreelanceDetailDrawer.vue?vue&type=style&index=0&id=951d6704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-951d6704"]])

export default __exports__